import React from 'react'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { toggleRequiredLicense } from '../../actions/users'

class SwitchLabel extends React.Component {
  // state = {
  //   checkedB: true
  // }

  render() {
    const {
      label,
      handleChange,
      authentication
      //  toggle
    } = this.props
    const { license_required } = authentication.authenticatedUser
    const isLicenseRequired = Boolean(license_required)

    return (
      <FormGroup row>
        <FormControlLabel
          control={
            <Switch
              checked={isLicenseRequired}
              onChange={handleChange()}
              color="primary"
            />
          }
          label={label}
        />
      </FormGroup>
    )
  }
}

const mapStateToProps = store => {
  // console.log(store)
  return {
    // toggle: store.toggle,
    authentication: store.authentication
  }
}

// TODO dispatch thunk hit new endpoint
const mapActionsToProps = dispatch => {
  return {
    handleChange: () => event => {
      dispatch(toggleRequiredLicense(event.target.checked))
    }
  }
}

export default compose(
  connect(
    mapStateToProps,
    mapActionsToProps
  )
)(SwitchLabel)
